import {Decoration, EditorView, WidgetType} from '@codemirror/view';
import {RangeSet, StateField} from '@codemirror/state';
import {syntaxTree} from '@codemirror/language';

export const emojiPreview = (emojiUrl) => {
  return StateField.define({
    create(state) {
      return widgetsRangeSet(state);
    },
    update(previews, transaction) {
      if (transaction.docChanged) {
        return widgetsRangeSet(transaction.state);
      }
      return previews.map(transaction.changes);
    },
    provide(field) {
      return EditorView.decorations.from(field);
    },
  });

  function widgetsRangeSet(state) {
    const widgets = [];
    syntaxTree(state).iterate({
      enter({from, to, name}) {
        if (name === 'Emoji') {
          const emojiName = state.doc.sliceString(from + 1, to - 1);
          const url = emojiUrl(emojiName);
          if (url !== null) {
            widgets.push(previewWidget(url).range(from));
          }
        }
      },
    });
    if (widgets.length > 0) {
      return RangeSet.of(widgets);
    }
    return Decoration.none;
  }

  function previewWidget(url) {
    return Decoration.widget({widget: new EmojiWidget(url), side: 1});
  }
};

class EmojiWidget extends WidgetType {
  constructor(url) {
    super()
    this.url = url;
  }

  eq(other) {
    return other.url === this.url;
  }

  toDOM() {
    const image = document.createElement('img');
    image.className = 'cm-emoji-preview';
    image.src = this.url;
    return image;
  }
}
